import { BOXSETS_HAS_ERRORED, BOXSETS_IS_LOADING, BOXSETS_DATA_SUCCESS } from './types';
import { globalFetch } from './globalActions';
import { FEED_URLSRC_CMS_V2 } from '../constants';
import { isCmsImage } from '../helpers';

///////////
// Boxsets Feed //
///////////

export function boxsetsFetchDataSuccess(items) {

	let cardItems = [], res = {};
	if (items.result.cards && Object.keys(items.result.cards).length > 0) {
		Object.entries(items.result.cards).forEach(([key, value]) => {
			cardItems[key] = { id: items.result.cards[key].programmeId, title: items.result.cards[key].preTitle, subTitle: items.result.cards[key].title, thumbnail: items.result.cards[key].image.path, isCMSThumbnail: isCmsImage(items.result.cards[key].image.url), isActions: true, count: items.result.cards[key].itemsCount, billing: items.result.cards[key].description };
		});

		res.cards = cardItems;
		res.title = items.result.title;
		res.description = items.result.description;
	}

	return {
		type: BOXSETS_DATA_SUCCESS,
		payload: res
	};
}

export function boxsetsFetchData() {
	return globalFetch({
		urlPath: "box-set",
		urlSrc: FEED_URLSRC_CMS_V2,
		reducerIsLoading: BOXSETS_IS_LOADING,
		reducerError: BOXSETS_HAS_ERRORED,
		dispatchSuccess: (itemObj, dispatch) => {
			dispatch(boxsetsFetchDataSuccess(itemObj));
		}
	});
}
